module.exports = __webpack_public_path__ + "static/media/handshake_black_24dp.5ead383f.svg";